import {boolean} from './booleanAnnotation'

/**
 * Annotation builder for a disabled property of a component with type 'boolean'.
 */
export const disabled = boolean.setup({disabled: true})
